import { useEffect, useMemo } from "react";
import { HOMEPAGE_TEMPLATE_OPTIONS } from "../../Registry/index.js";

function slugify(input = "") {
  return input
    .trim()
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "")
    .slice(0, 40);
}

function Step1CreateHomepage({
  templateId,
  setTemplateId,
  name,
  setName,
  slug,
  setSlug,
  slugTouched,
  setSlugTouched,
  slugStatus,
  templateAccess = [],
}) {
  useEffect(() => {
    if (slugTouched) return;
    setSlug(slugify(name || ""));
  }, [name, slugTouched, setSlug]);

  const allowedTemplateIds = useMemo(() => {
    return templateAccess.map((item) => item.template_id);
  }, [templateAccess]);

  const filteredTemplates = useMemo(() => {
    return HOMEPAGE_TEMPLATE_OPTIONS.filter((t) => {
      if (t.id === "default-homepage") return true;
      return allowedTemplateIds.includes(t.id);
    });
  }, [allowedTemplateIds]);

  useEffect(() => {
    if (!filteredTemplates.some((t) => t.id === templateId)) {
      if (filteredTemplates.length > 0) {
        setTemplateId(filteredTemplates[0].id);
      }
    }
  }, [filteredTemplates, templateId, setTemplateId]);

  return (
    <div className="card">
      <h2>Choose your homepage template</h2>

      <div className="templates">
        {filteredTemplates.map((t) => (
          <button
            key={t.id}
            type="button"
            className={`tpl ${templateId === t.id ? "active" : ""}`}
            onClick={() => setTemplateId(t.id)}
          >
            <div className="tpl-name">{t.name}</div>
            <div className="tpl-desc">{t.desc}</div>
          </button>
        ))}
      </div>

      <label className="field">
        <span>Organization name</span>
        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Fast Action Basketball"
        />
      </label>

      <label className="field">
        <span>SportingHip link</span>
        <div className="slug-row">
          <div className="slug-prefix">sportinghip.com/</div>
          <input
            value={slug}
            onChange={(e) => {
              setSlugTouched(true);
              setSlug(slugify(e.target.value));
            }}
            placeholder="fastactionbasketball"
          />
        </div>

        <div className="slug-status">
          {slugStatus?.checking ? (
            <span className="muted">Checking…</span>
          ) : slugStatus?.message ? (
            <span className={slugStatus.available === false ? "bad" : "good"}>
              {slugStatus.available === false ? "✖ " : "✓ "}
              {slugStatus.message}
            </span>
          ) : (
            <span className="muted">Choose your public SportingHip link.</span>
          )}
        </div>
      </label>
    </div>
  );
}

export default Step1CreateHomepage;